import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { PlaceContext, ObjContext, MakeContext, DefeatContext } from "./context";

export class Priest extends UnitType {
    readonly id = "priest";
    readonly displayName = "Priest";
    description() { return "Provides souls when snatched.\nRemoves influence."; }
    canEnter(ctx: PlaceContext) { return this.inTile(ctx, ["land"], ctx.game.overworld); }
    onDefeat(ctx: DefeatContext) { ctx.game.addResource(ctx.attacker.faction, "souls", 2); }
    maxCooldown() { return 5000; }
    moveRange() { return 4; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "priest"); }
    step(ctx: ObjContext) {
        this.hunt(ctx, c => c.game.influenceMap.get(c.x, c.y) ? 1 : 0);
        ctx.game.influenceMap.remove(ctx.x, ctx.y);
    }
    influenceRange(): number { return 3; }

}
